import React from 'react';

interface Props {
  className?: string,
}

export const Card: React.FC<Props> = ({ children, className }) => (
  <div
    className={`bg-white rounded ${className || 'shadow-sm'}`}
    data-qa="layout-card"
  >
    {children}
  </div>
);
